import React, { useEffect, useState } from 'react';

import { CreateReasonCodeDto, useCreateReasonCode } from '../../hooks/useCreateReasonCode';
import { useGetPaginatedReasonCodes } from '../../hooks/useGetPaginatedReasonCodes';
import { useToggleReasonCode } from '../../hooks/useToggleReasonCode';
import AddNewReasonModal from '../AddNewReasonModal/AddNewReasonModal';
import ReasonCodesTable from '../ReasonCodesTable/ReasonCodesTable';
import Pagination from '@/components/common/Pagination/Pagination';

interface IReasonTypeTabProps {
  reasonType: ReasonType;
}

export default function ReasonTypeTab({ reasonType }: IReasonTypeTabProps) {
  const [isVisbleModal, setIsVisbleModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { getReasonCodes, reasonCodes, isLoading, totalPages } = useGetPaginatedReasonCodes();
  const { toggleReasonCode } = useToggleReasonCode();
  const { createReasonCode } = useCreateReasonCode();
  const isVisiblePagination = !isLoading && reasonCodes?.length > 0 && totalPages > 1;

  useEffect(() => {
    getReasonCodes(reasonType.type, currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const onSubmitForm = (newReasonCode: CreateReasonCodeDto) => {
    createReasonCode(newReasonCode, currentPage, () => {
      setIsVisbleModal(false);
    });
  };

  return (
    <>
      {isVisbleModal && (
        <AddNewReasonModal
          reasonType={reasonType}
          onClose={() => setIsVisbleModal(false)}
          onSubmit={onSubmitForm}
        />
      )}

      <ReasonCodesTable
        reasonType={reasonType}
        rows={reasonCodes}
        onAddNewReasonName={() => setIsVisbleModal(true)}
        onToggleReasonName={toggleReasonCode}
        isLoading={isLoading}
      />

      {isVisiblePagination && (
        <div className="mt-20 d-flex just">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onClickPage={setCurrentPage}
          />
        </div>
      )}
    </>
  );
}
